var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Google SVG",
    clipPath: "url(#clip0_0_4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.0334 4.0134C11.5249 4.0134 12.8605 4.52883 13.9139 5.53426L16.8 2.6404C15.0472 1.00546 12.7594 0 10.0334 0C6.08128 0 2.66426 2.27285 1 5.58495L4.36224 8.2C5.15854 5.79622 7.39584 4.0134 10.0334 4.0134Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.6 10.1266C19.6 9.4618 19.5373 8.8182 19.4413 8.2H10V12.0193H15.4057C15.1634 13.2726 14.4616 14.3396 13.4089 15.0595L16.6381 17.6C18.5222 15.8301 19.6 13.2133 19.6 10.1266Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.4 11.9586C4.19943 11.3399 4.08246 10.6828 4.08246 10C4.08246 9.31727 4.19525 8.66013 4.4 8.0414L1.06553 5.4C0.384427 6.78256 0 8.34436 0 10C0 11.6557 0.384427 13.2174 1.06971 14.6L4.4 11.9586Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.0763 20C12.8183 20 15.1244 19.1005 16.8 17.5467L13.5291 15.0133C12.6194 15.6255 11.4473 15.9844 10.0763 15.9844C7.42748 15.9844 5.18059 14.2025 4.37665 11.8L1 14.4137C2.67563 17.7283 6.10729 20 10.0763 20Z",
    fill: "#34A853"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.69fd4b61bd5e801ec8c161f935ebe050.svg";
export { ForwardRef as ReactComponent };